import { css } from 'styled-components';

export const starRating = css`
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
`;
